export default __webpack_public_path__ + "static/media/iphone.9714f71e.svg";